export const formatResponse = ({ data, status }) => ({
  data,
  status,
});

export const no = {};
